var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banners'),_c('About'),_c('Gallery'),_c('Services'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }